module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"days":"Days","hours":"Hours","minutes":"Minutes","seconds":"Seconds"},"es":{"days":"Días","hours":"Horas","minutes":"Minutos","seconds":"Segundos"}}')
  delete Component.options._Ctor
}
